<template lang="pug">
div
  section.full__video
    .intro__content.intro__content--mobile.influencerlp--header
      img#productLogo(srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x')
      h2 $1 for 1 Month
      h2 Cinemagraphs made easy. Get a Mobile plan for just $1 for your first month and start creating imagery that gets noticed in as little as 1 minute. Don't miss this incredible chance to bring your stories to life!
      .btn__group.btn__group--splash
        get-plan(
          classes='btn btn--purpleLight btn__splash',
          coupon='1DOLLARDEAL',
          copy='Claim offer',
          monthly='1',
        )
    .fluid__video
      .intro__content.intro__content--desktop.influencerlp--header
        img#productLogo(srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x')
        h2 $1 for 1 Month
        h2 Cinemagraphs made easy. Get a Mobile plan for just $1 for your first month and start creating imagery that gets noticed in as little as 1 minute. Don't miss this incredible chance to bring your stories to life!
        .btn__group.btn__group--splash
          get-plan(
            classes='btn btn--purpleLight btn__splash',
            coupon='1DOLLARDEAL',
            copy='Claim offer',
            monthly='1',
          )
      .video__overlay
        iframe(src='https://media.flixel.com/cinemagraph/nu7dtkopaqqksl3yqefy?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/ThomasB/') ThomasB
  
  section.product__section--ios
    .product__section.product__section--ios
      .product__section--container.product__section--reverse
        .product__section--content
          .productItem__title
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon@2x.png 2x,https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon.png 1x')
            h2
              | Cinemagraph Pro
              span for iOS
          .productItem__desc
            p The magic and ease of Cinemagraph Pro right at your fingertips. Capture, edit and create professional quality cinemagraphs on-the-go with your iPhone or iPad.
            .btn__group
              a.btn.btn--black(href='https://itunes.apple.com/ca/app/cinemagraph-pro/id642139481?mt=8') Download free trial
              get-plan(
                classes='btn btn--white',
                coupon='1DOLLARDEAL',
                copy='Claim offer',
                monthly='1',)
        .product__section--image
          img.lazy#iosImage(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios.png 1x')

  section.landingPage__section--marketers
    .landingPage__section--video
      h2 Cinemagraphs Go Mobile
      p With advanced features and a simplified process, Cinemagraph Pro makes cinemagraph creation fun, fast, and incredibly easy. Compose your shot like a photo with repeated motion and capture perfectly still video footage from a tripod. Import your video into Cinemagraph Pro for iOS and let the magic begin!
      .video
        div(style='position:relative; height:0; padding-bottom:59.97%; width:100%')
          iframe(style='position:absolute; top:0; left:0; width:100%; height:100%; pointer-events: all;', src="https://www.youtube.com/embed/8S9zTjkbyso?rel=0&amp;showinfo=0" showinfo="0" frameborder="0" allow='autoplay')

  section
    .product__section
      .product__section--highlights
        .highlights--title
          h2 Cinemagraph Pro for iOS is Your Mobile Creation Studio
          p Cinemagraph Pro for iOS lets you take professional cinemagraph production on-the-go. Create thumb-stopping cinemagraphs on an iPhone or iPad and share them instantly on social media, websites, as Facebook ads and more.

        .highlights
          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/features/4kcinemagraphs@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/4kcinemagraphs.png 1x')
            .highlight__item--title
              h3 4K Cinemagraphs From Your iPhone or iPad
            .highlight__item--desc
              p Shoot perfectly still footage from a tripod or repurpose your existing videos. You can record, edit, and share 4K Cinemagraphs on supported iOS devices and tell your story as vividly as you would like.

          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/features/apowerfulcinemagraph@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/apowerfulcinemagraph.png 1x')
            .highlight__item--title
              h3 A Powerful Cinemagraph Creation Tool in Your Pocket
            .highlight__item--desc
              p Bring the entire cinemagraph creation process right to your fingertips. Capture or import your video, trim your clip, select your still image and paint over it to reveal the motion. Make adjustments and style your cinemagraph. That's all there is to it.

          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/features/easytocreate@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/easytocreate.png 1x')
            .highlight__item--title
              h3 Easy to Create. Easy to Share.
            .highlight__item--desc
              p Optimize your cinemagraphs for social media or customize the export settings. Share instantly to connected social networks or save to your camera roll for later. Upload to your public gallery for the chance to be featured in Flixel galleries and more.

          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/features/controlapplewatch@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/controlapplewatch.png 1x')
            .highlight__item--title
              h3 Take Control with Your Apple Watch
            .highlight__item--desc
              p Your Apple Watch is your personal remote control. Capture your cinemagraph by setting a countdown timer, or use it as a remote shutter release so that you can perfect your cinemagraph selfie.

  section.influencerlp
    .product__callout
      .callout--container
        h1 Bring Your Stories to Life with Cinemagraphs
        p Composed like a photo and brought to life with a subtle hint of repeating video motion, cinemagraphs tell vivid stories that engage audiences and drive results. Get a Mobile plan for just $1 for your first month and start creating imagery that gets noticed in as little as 1 minute.
        .btn__group        
          get-plan(
            classes='btn btn--purpleLight btn__splash',
            coupon='1DOLLARDEAL',
            copy='Claim offer',
            monthly='1',
          )

  section.product__section.product__section--carousel
    .carousel__item.fluid__video.carousel__item--wide
      iframe(data-src='https://media.flixel.com/cinemagraph/t1d1hq1xjbsxc2dxz6g1?hd=true' allow='autoplay')
    .carousel__item.fluid__video.carousel__item--thin
      iframe(data-src='https://media.flixel.com/cinemagraph/fmou1dsz9f44agosgkbj?hd=true' allow='autoplay')
    .carousel__item.fluid__video.carousel__item--wide
      iframe(data-src='https://media.flixel.com/cinemagraph/nrldxc67hri302eescck?hd=true' allow='autoplay')
    .carousel--mobile
      iframe(data-src='https://media.flixel.com/cinemagraph/t1d1hq1xjbsxc2dxz6g1?hd=true' allow='autoplay')

  section.carousel__attributions
    h2 Check out more by the artists featured here.
    .attributions
      a(href='https://flixel.com/mrjonkane/' target="_blank") mrjonkane
      a(href='https://flixel.com/VirgoHaan/' target="_blank") VirgoHaan
      a(href='https://flixel.com/michelmolder/' target="_blank") michelmolder
    .attributions--mobile
      a(href='https://flixel.com/michelmolder/' target="_blank") michelmolder
</template>

<script>
import getPlan from '../../../../components/getPlan.vue';

export default {
  name: '1 Dollar Deal LP',
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
  },
  methods: {
    ytModal(event) {
      event.preventDefault();
      const ytURL = event.currentTarget.getAttribute('href');
      const iframeURL = ytURL.split('v=')[1];
      const videoHeight = window.innerHeight - 200;
      const videoWidth = window.innerWidth - 200;

      this.modalShow = true;
      // jQuery remove
      $('body').bind('touchmove', function (e) {
        e.preventDefault();
      });
      this.ytVideo = '<iframe height=' + videoHeight + ' width= ' + videoWidth + ' src="https://www.youtube.com/embed/' + iframeURL + '?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';
    },
    overlay() {
      $('body').unbind('touchmove');
      this.modalShow = false;
      this.modalProduct = false;
    },
  },
  components: {
    'getPlan': getPlan,
  },
};
</script>




// WEBPACK FOOTER //
// src/views/landingPages/offers/fb/1dollardeal.vue